
import { toast } from 'sonner';

const FUNCTION_URL = "https://nzbrwnqbsdtxyaifmvcn.supabase.co/functions/v1/legal-chatbot";

export interface ChatbotResponse {
  success: boolean;
  content: string;
  error?: string;
  documentRecommendations?: DocumentRecommendation[];
}

export interface DocumentRecommendation {
  title: string;
  description: string;
  templateId: string;
}

// Track donation for analytics
export function trackDonation(amount: string): void {
  try {
    // Get the current donations count and total
    const donationsCount = parseInt(localStorage.getItem('adaaltDonationsCount') || '0');
    const donationsTotal = parseFloat(localStorage.getItem('adaaltDonationsTotal') || '0');
    
    // Update the count and total
    localStorage.setItem('adaaltDonationsCount', (donationsCount + 1).toString());
    localStorage.setItem('adaaltDonationsTotal', (donationsTotal + parseFloat(amount)).toString());
    
    console.log(`Donation tracked: $${amount}`);
  } catch (e) {
    console.error("Error tracking donation:", e);
  }
}

export async function askLegalQuestion(question: string, language = 'ur'): Promise<ChatbotResponse> {
  try {
    // Track question count
    const currentCount = parseInt(localStorage.getItem('adaaltBotChatCount') || '0');
    localStorage.setItem('adaaltBotChatCount', (currentCount + 1).toString());
    
    const response = await fetch(FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        question,
        language
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("API Error:", errorData);
      throw new Error(errorData.error || (language === 'ur' ? "API خرابی، براہ کرم دوبارہ کوشش کریں" : "API error, please try again"));
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || (language === 'ur' ? "کوئی نتیجہ نہیں ملا" : "No result found"));
    }

    // Track successful questions
    try {
      const successCount = parseInt(localStorage.getItem('adaaltBotSuccessCount') || '0');
      localStorage.setItem('adaaltBotSuccessCount', (successCount + 1).toString());
    } catch (e) {
      console.error("Error updating success count:", e);
    }

    return {
      success: true,
      content: data.content,
      documentRecommendations: data.documentRecommendations
    };
  } catch (error) {
    console.error("Chatbot error:", error);
    
    // Track failed questions
    try {
      const failCount = parseInt(localStorage.getItem('adaaltBotFailCount') || '0');
      localStorage.setItem('adaaltBotFailCount', (failCount + 1).toString());
    } catch (e) {
      console.error("Error updating fail count:", e);
    }
    
    const errorMessage = error instanceof Error ? error.message : (language === 'ur' ? "نامعلوم خرابی" : "Unknown error");
    
    return {
      success: false,
      content: language === 'ur' 
        ? "معذرت، میں آپ کے سوال کا جواب نہیں دے سکتا۔ براہ کرم دوبارہ کوشش کریں یا اپنا سوال واضح کریں۔"
        : "Sorry, I couldn't answer your question. Please try again or clarify your question.",
      error: errorMessage
    };
  }
}
